/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CreateCommunicationResponseDto,
  DataEnvelopeOfCommunicationResponseDto,
  DataEnvelopeOfListOfCommunicationResponseDto,
  DataEnvelopeOfObject,
  ErrorEnvelope,
  UpdateCommunicationResponseDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Lista todas as respostas de um comunicado
 */
export const getCommunicationResponses = (
  communicationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfListOfCommunicationResponseDto>(
    { url: `/v1/communications/${communicationId}/responses`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationResponsesQueryKey = (communicationId: string) => {
  return [`/v1/communications/${communicationId}/responses`] as const
}

export const getGetCommunicationResponsesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationResponses>>,
  TError = ErrorEnvelope,
>(
  communicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationResponsesQueryKey(communicationId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationResponses>>> = ({
    signal,
  }) => getCommunicationResponses(communicationId, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: communicationId !== null && communicationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCommunicationResponsesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationResponses>>
>
export type GetCommunicationResponsesQueryError = ErrorEnvelope

export function useGetCommunicationResponses<
  TData = Awaited<ReturnType<typeof getCommunicationResponses>>,
  TError = ErrorEnvelope,
>(
  communicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationResponses>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationResponses>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationResponses<
  TData = Awaited<ReturnType<typeof getCommunicationResponses>>,
  TError = ErrorEnvelope,
>(
  communicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationResponses>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationResponses>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationResponses<
  TData = Awaited<ReturnType<typeof getCommunicationResponses>>,
  TError = ErrorEnvelope,
>(
  communicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todas as respostas de um comunicado
 */

export function useGetCommunicationResponses<
  TData = Awaited<ReturnType<typeof getCommunicationResponses>>,
  TError = ErrorEnvelope,
>(
  communicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationResponses>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationResponsesQueryOptions(communicationId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Adiciona resposta/comentário em um comunicado
 */
export const createCommunicationResponse = (
  communicationId: string,
  createCommunicationResponseDto: CreateCommunicationResponseDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationResponseDto>(
    {
      url: `/v1/communications/${communicationId}/responses`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCommunicationResponseDto,
      signal,
    },
    options,
  )
}

export const getCreateCommunicationResponseMutationKey = () =>
  ['createCommunicationResponse'] as const

export const getCreateCommunicationResponseMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunicationResponse>>,
    TError,
    CreateCommunicationResponseMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunicationResponse>>,
  TError,
  CreateCommunicationResponseMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCommunicationResponseMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunicationResponse>>,
    CreateCommunicationResponseMutationVariables
  > = (props) => {
    const { communicationId, data } = props ?? {}

    return createCommunicationResponse(communicationId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCommunicationResponseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunicationResponse>>
>
export type CreateCommunicationResponseMutationBody = CreateCommunicationResponseDto
export type CreateCommunicationResponseMutationError = ErrorEnvelope
export type CreateCommunicationResponseMutationVariables = {
  communicationId: string
  data: CreateCommunicationResponseDto
}

/**
 * @summary Adiciona resposta/comentário em um comunicado
 */
export const useCreateCommunicationResponse = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommunicationResponse>>,
      TError,
      CreateCommunicationResponseMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommunicationResponse>>,
  TError,
  CreateCommunicationResponseMutationVariables,
  TContext
> => {
  return useMutation(getCreateCommunicationResponseMutationOptions(options), queryClient)
}
/**
 * @summary Atualiza resposta (apenas autor)
 */
export const updateCommunicationResponse = (
  responseUuid: string,
  updateCommunicationResponseDto: UpdateCommunicationResponseDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationResponseDto>(
    {
      url: `/v1/communications/responses/${responseUuid}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCommunicationResponseDto,
      signal,
    },
    options,
  )
}

export const getUpdateCommunicationResponseMutationKey = () =>
  ['updateCommunicationResponse'] as const

export const getUpdateCommunicationResponseMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunicationResponse>>,
    TError,
    UpdateCommunicationResponseMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunicationResponse>>,
  TError,
  UpdateCommunicationResponseMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCommunicationResponseMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunicationResponse>>,
    UpdateCommunicationResponseMutationVariables
  > = (props) => {
    const { responseUuid, data } = props ?? {}

    return updateCommunicationResponse(responseUuid, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCommunicationResponseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunicationResponse>>
>
export type UpdateCommunicationResponseMutationBody = UpdateCommunicationResponseDto
export type UpdateCommunicationResponseMutationError = ErrorEnvelope
export type UpdateCommunicationResponseMutationVariables = {
  responseUuid: string
  data: UpdateCommunicationResponseDto
}

/**
 * @summary Atualiza resposta (apenas autor)
 */
export const useUpdateCommunicationResponse = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunicationResponse>>,
      TError,
      UpdateCommunicationResponseMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunicationResponse>>,
  TError,
  UpdateCommunicationResponseMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCommunicationResponseMutationOptions(options), queryClient)
}
/**
 * @summary Remove resposta (apenas autor ou admin)
 */
export const deleteCommunicationResponse = (
  responseUuid: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/communications/responses/${responseUuid}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteCommunicationResponseMutationKey = () =>
  ['deleteCommunicationResponse'] as const

export const getDeleteCommunicationResponseMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunicationResponse>>,
    TError,
    DeleteCommunicationResponseMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunicationResponse>>,
  TError,
  DeleteCommunicationResponseMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCommunicationResponseMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunicationResponse>>,
    DeleteCommunicationResponseMutationVariables
  > = (props) => {
    const { responseUuid } = props ?? {}

    return deleteCommunicationResponse(responseUuid, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCommunicationResponseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunicationResponse>>
>

export type DeleteCommunicationResponseMutationError = ErrorEnvelope
export type DeleteCommunicationResponseMutationVariables = { responseUuid: string }

/**
 * @summary Remove resposta (apenas autor ou admin)
 */
export const useDeleteCommunicationResponse = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCommunicationResponse>>,
      TError,
      DeleteCommunicationResponseMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunicationResponse>>,
  TError,
  DeleteCommunicationResponseMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCommunicationResponseMutationOptions(options), queryClient)
}
